import { j as t } from "../../../../../node_modules/react/jsx-runtime.js";
import r from "../../../../atoms/Checkbox/Checkbox.js";
import m from "../../../../atoms/Tooltip/Tooltip.js";
import g from "../../../../../node_modules/lodash/isEmpty.js";
const f = (d = !0, l) => {
  const o = {
    id: "select-col",
    // @ts-expect-error // accessorFn Type need to be fixed
    accessorFn: (e) => e["select-col"],
    width: "40px",
    // @ts-expect-error // header Type need to be fixed
    header: ({ table: e }) => /* @__PURE__ */ t.jsx("div", { className: "flex w-full h-full justify-center items-center cursor-pointer", children: /* @__PURE__ */ t.jsx(
      r,
      {
        id: "table-global-checkbox",
        active: e.getIsAllRowsSelected() || e.getIsSomeRowsSelected(),
        onChange: e.getToggleAllRowsSelectedHandler(),
        indeterminate: e.getIsSomeRowsSelected(),
        "data-testid": "table-global-checkbox"
      }
    ) }),
    alignment: "center",
    // @ts-expect-error // cell Type need to be fixed
    cell: ({ row: e }) => {
      var i, s, n;
      const c = (i = l(e.original)) == null ? void 0 : i.disabled, a = c && !g((s = l(e.original)) == null ? void 0 : s.disabledTooltip);
      return /* @__PURE__ */ t.jsx(
        "div",
        {
          className: `flex w-full h-full justify-center items-center ${c ? "cursor-not-allowed" : "cursor-pointer"}`,
          children: /* @__PURE__ */ t.jsx(
            m,
            {
              ...a && ((n = l(e.original)) == null ? void 0 : n.disabledTooltip),
              trigger: /* @__PURE__ */ t.jsx(
                r,
                {
                  id: e.id,
                  disabled: !e.getCanSelect(),
                  active: e.getIsSelected(),
                  ...e.getCanSelect() && { onChange: () => e.toggleSelected() }
                }
              )
            }
          )
        }
      );
    }
  };
  return {
    ...d ? { id: "select", width: "40px", columns: [o] } : o
  };
};
export {
  f as getTableSelectColumn
};
//# sourceMappingURL=getTableSelectColumn.js.map
